import { translateText } from './Translations';

let isObserving = false;
let observer = null;

export const translateNode = (node) => {
    if (node.nodeType === Node.ELEMENT_NODE) {
        // Skip elements with 'no-translate' class or if they are inside one
        if (node.closest && node.closest('.no-translate')) return;

        const tag = node.tagName.toLowerCase();
        if (['script', 'style', 'noscript', 'code'].includes(tag)) return;

        // Translate placeholders for inputs and textareas
        if ((tag === 'input' || tag === 'textarea') && node.placeholder) {
            const original = node.getAttribute('data-original-placeholder') || node.placeholder;
            if (!node.hasAttribute('data-original-placeholder')) {
                node.setAttribute('data-original-placeholder', original);
            }
            const translated = translateText(original);
            if (translated !== node.placeholder) {
                node.placeholder = translated;
            }
        }

        node.childNodes.forEach(translateNode);
    } else if (node.nodeType === Node.TEXT_NODE) {
        if (node.parentElement && node.parentElement.closest && node.parentElement.closest('.no-translate')) return;
        const originalText = node.originalValue !== undefined ? node.originalValue : node.nodeValue;
        if (!originalText || !originalText.trim()) return;

        if (node.originalValue === undefined) {
            node.originalValue = originalText;
        }

        const translated = translateText(originalText);
        if (translated !== node.nodeValue) {
            node.nodeValue = translated;
        }
    }
};

export const retranslateAll = () => {
    translateNode(document.body);

    const titleElement = document.querySelector('title');
    if (titleElement) {
        translateNode(titleElement);
    }
};

export const initTranslationObserver = () => {
    if (isObserving) return;
    isObserving = true;

    observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach((node) => {
                    translateNode(node);
                });
            } else if (mutation.type === 'characterData') {
                const node = mutation.target;

                // Ignore if it's inside a no-translate element
                if (node.parentElement && node.parentElement.closest('.no-translate')) return;

                const newText = node.nodeValue;

                if (node.originalValue === undefined) {
                    node.originalValue = mutation.oldValue || newText;
                }

                const expectedTranslation = translateText(node.originalValue);
                if (newText === expectedTranslation) return; // We caused this mutation, ignore

                // React caused this mutation with new text
                node.originalValue = newText;
                const translated = translateText(newText);
                if (translated !== newText) {
                    node.nodeValue = translated;
                }
            }
        });
    });

    translateNode(document.body);

    const titleElement = document.querySelector('title');
    if (titleElement) {
        translateNode(titleElement);
    }

    observer.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true,
        characterDataOldValue: true
    });

    if (titleElement) {
        observer.observe(titleElement, {
            childList: true,
            subtree: true,
            characterData: true,
            characterDataOldValue: true
        });
    }
};
